import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { IonicModule } from '@ionic/angular';
import { CountdownTimerComponent } from './countdown-timer/countdown-timer.component';
import { MenuItemComponent } from './menu/menu-item.component';
import { MenuSubmenuComponent } from './menu/menu-submenu.component';
import { MenuComponent } from './menu/menu.component';
import { ProgressComponent } from './progress/progress.component';

const COMPONENTS = [
  MenuComponent,
  MenuItemComponent,
  MenuSubmenuComponent,
  CountdownTimerComponent,
  ProgressComponent,
]

@NgModule({
  declarations: COMPONENTS,
  exports: COMPONENTS,
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
  ]
})
export class ComponentsModule { }
